import styled from 'styled-components';
import { Heading3 } from '@origin-digital/style-guide';
import { LG } from '@origin-digital/helper';
import * as React from 'react';

interface CenteredHeadingProps {
  text: string;
}

const CenteredHeading: React.FC<CenteredHeadingProps> = ({ text }) => (
  <CenteredHeadingContainer data-id="heading-container">
    <Heading3 align="center" text={text} data-id="heading" />
  </CenteredHeadingContainer>
);

const CenteredHeadingContainer = styled.div`
  text-align: center;
  margin-bottom: 16px;
  ${LG`
    margin-bottom: 24px;
  `}
`;

export { CenteredHeading };
